import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import { countBlanks, formatProblem } from "../../../utils/quiz-parser.js";
import { getImageUrl, getPrintScale, PRINT_CORRECT_ANSWER_CLASS, getStyles, PrintQuizTitle, PrintQuizImage, PrintWordBank } from "./print-common.js";
function DragTextPrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  var _a;
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const blankCount = countBlanks(quiz.problem);
  const optionLabelByKey = /* @__PURE__ */ new Map();
  if (quiz.choices && Array.isArray(quiz.choices)) {
    quiz.choices.forEach((c) => {
      if ((c == null ? void 0 : c.key) && (c == null ? void 0 : c.answer)) optionLabelByKey.set(c.key, c.answer);
    });
  }
  if (((_a = quiz.pairs) == null ? void 0 : _a.right) && Array.isArray(quiz.pairs.right)) {
    quiz.pairs.right.forEach((c) => {
      if ((c == null ? void 0 : c.key) && (c == null ? void 0 : c.answer)) optionLabelByKey.set(c.key, c.answer);
    });
  }
  const resolveLabel = (value) => optionLabelByKey.get(value) ?? value;
  const wordBankItems = (() => {
    var _a2, _b, _c, _d;
    if ((_a2 = quiz.choices) == null ? void 0 : _a2.length) {
      return quiz.choices.filter((c) => Boolean(c) && typeof c.key === "string" && typeof c.answer === "string").map((c) => ({ key: c.key, label: c.answer }));
    }
    if ((_c = (_b = quiz.pairs) == null ? void 0 : _b.right) == null ? void 0 : _c.length) {
      return quiz.pairs.right.filter((c) => Boolean(c) && typeof c.key === "string" && typeof c.answer === "string").map((c) => ({ key: c.key, label: c.answer }));
    }
    if ((_d = quiz.answers) == null ? void 0 : _d.length) {
      return quiz.answers.map((a) => {
        if (typeof a === "string") return { key: a, label: a };
        return { key: a.key || a.answer, label: a.answer };
      }).filter((a) => typeof a.key === "string" && a.key.length > 0);
    }
    return [];
  })();
  const renderedProblem = blankCount > 0 ? formatProblem(
    quiz.problem,
    `${quizId}-print-problem`,
    (index) => {
      const answer = correctAnswers == null ? void 0 : correctAnswers[index];
      const label = answer ? resolveLabel(answer) : null;
      const showAnswer = showCorrectAnswers && label;
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: cn(
            s.inputBoxLg,
            `inline-flex items-center justify-center ${compact ? "mx-[8px] my-[4px]" : "mx-[12px]"} px-[8px] align-middle text-[16px]`,
            showAnswer ? PRINT_CORRECT_ANSWER_CLASS : ""
          ),
          children: showAnswer ? /* @__PURE__ */ jsx(KatexText, { text: label }) : " "
        },
        `blank-print-${quizId}-${index}`
      );
    },
    quiz.additionalImages ?? void 0
  ) : [];
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    blankCount > 0 && /* @__PURE__ */ jsx("div", { className: s.problemArea, children: /* @__PURE__ */ jsx("div", { className: cn(
      s.problemLine,
      compact ? "text-[15px] text-black tracking-[-0.09px] font-normal leading-[41px]" : s.problemText
    ), children: renderedProblem }) }),
    /* @__PURE__ */ jsx("div", { className: "pl-[40px] w-full", children: /* @__PURE__ */ jsx(PrintWordBank, { items: wordBankItems, compact }) })
  ] });
}
export {
  DragTextPrint
};
//# sourceMappingURL=drag-text-print.js.map
